import { useEffect, useState } from "react";
import { ChefHat, Home } from "lucide-react";
import "./LiveTrackDemo.css";

/* A subtle, looping "your chef is on the way" demo for the landing hero.
 * Pure CSS + SVG — no libs, no canvas, respects prefers-reduced-motion. */
export default function LiveTrackDemo() {
  // Animate ETA countdown 8 → 0 → 8, synced with the 7s chef loop
  const [eta, setEta] = useState(8);
  useEffect(() => {
    const id = setInterval(() => {
      setEta((e) => (e <= 1 ? 8 : e - 1));
    }, 800);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="ltd-card" data-testid="live-track-demo" aria-label="Live chef tracking demo">
      <div className="ltd-grid" />

      {/* Decorative route path */}
      <svg className="ltd-streets" viewBox="0 0 800 450" preserveAspectRatio="none">
        <path className="ltd-route" d="M 144 99 Q 250 180 360 144 T 520 240 Q 600 310 624 324" />
        <path className="ltd-route-fill" d="M 144 99 Q 250 180 360 144 T 520 240 Q 600 310 624 324" />
      </svg>

      {/* Chef pin (animated) */}
      <div className="ltd-pin chef" data-testid="chef-pin">
        <ChefHat size={18} strokeWidth={2.2} />
      </div>

      {/* Home pin (fixed) */}
      <div className="ltd-pin home" style={{ top: "72%", left: "78%" }} data-testid="home-pin">
        <Home size={18} strokeWidth={2.2} />
      </div>
      <div className="ltd-label home" style={{ top: "72%", left: "78%" }}>Your kitchen</div>

      {/* ETA chip */}
      <div className="ltd-eta">
        <span className="ltd-eta-dot" />
        <div>
          <div style={{ fontSize: 11, color: "#1d1d1f", opacity: 0.55, lineHeight: 1 }}>Chef arriving in</div>
          <div className="ltd-eta-min">{eta} min</div>
        </div>
      </div>

      {/* Caption */}
      <div className="ltd-caption">
        <b>Chef Ramesh is on the way</b>
        <span>Tracked live · arrival selfie required</span>
      </div>
    </div>
  );
}
